import api from '@/lib/api/axios'

export interface IconItem {
    id: number
    filename: string
    description: string | null
    tags: string | null
}

export const iconsApi = {
    list: (search?: string) =>
        api.get<{ success: boolean; data: IconItem[] }>('/api/icons', {
            params: search ? { search } : undefined,
        }),

    create: (data: { filename: string; description?: string; tags?: string }) =>
        api.post<{ success: boolean; data: IconItem }>('/api/icons', data),

    /** Upload icon file to image server, then create DB record */
    upload: async (file: File, description?: string, tags?: string): Promise<IconItem> => {
        // 1. Upload file to image server
        const formData = new FormData()
        formData.append('file', file)
        formData.append('directory', 'foreground/icons')
        formData.append('imageName', file.name)

        const uploadRes = await fetch('/images/upload', {
            method: 'POST',
            body: formData,
        })

        if (!uploadRes.ok) {
            throw new Error('Failed to upload icon file')
        }

        const uploadData = await uploadRes.json()
        const filename = uploadData.data?.filename || file.name

        // 2. Create DB record
        const dbRes = await iconsApi.create({ filename, description, tags })
        return dbRes.data.data
    },
}
